<template>
  <div class="table">
    <a-tabs :activeKey="activeKey" class="menu" type="card" @change="changeTabs">
      <template v-for="(el, i) of getTabs">
        <a-tab-pane v-if="el.key === '1'" :key="el.key" :tab="el.title">
          <div class="searchMenu">
            <div class="item-box">
              <div></div>
              <div></div>
              <div></div>
              <div style="display: flex; align-items: center; width: 122px">
                <span :class="{ cur: curLook }" style="margin-right: 5px; width: 66px; cursor: pointer" @click="changeUpDown">带看</span>
                <a-select placeholder="全部" style="width: 100%" @change="dateListChange">
                  <a-select-option v-for="item in dateList" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
                <div class="icons" @click="changeUpDown">
                  <a-icon :class="{ cur: curLook && form.sortType == 'ASC' }" type="caret-up" />
                  <a-icon :class="{ cur: curLook && form.sortType == 'DESC' }" type="caret-down" />
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane v-else-if="el.key === '2'" :key="el.key" :tab="el.title" style="padding-top: 42px"></a-tab-pane>
<!--        <a-tab-pane v-else-if="el.key == '3' && getPosition.indexOf('2') >= 0" :key="el.key" :tab="el.title" style="padding-top: 42px"></a-tab-pane>-->
        <a-tab-pane v-else-if="el.key == '8' && getPosition.indexOf('1') >= 0" :key="el.key" :tab="el.title" style="padding-top: 42px"></a-tab-pane>
        <a-tab-pane
          v-else-if="el.key !== '1' && el.key !== '2' && el.key !== '3' && el.key !== '8'"
          :key="el.key"
          :tab="el.title"
          style="padding-top: 42px"
        ></a-tab-pane>
      </template>
    </a-tabs>
    <!-- 增加标识 判断是否进入的是租客列表 nameTouristComponent -->
    <component
      :is="componentId"
      :activeKey="activeKey"
      :activeNum="activeNum"
      :data-list="dataLists"
      :dishTypeOpts="dishTypeOpts"
      :nameTouristComponent="nameTouristComponent"
      @GoSorter="GoSorter"
    ></component>
    <!-- 分页 -->
    <a-pagination
      v-if="total"
      :current="pageNum"
      :pageSize="pageSize"
      :pageSizeOptions="pagination.pageSizeOptions"
      :showTotal="(total) => `共 ${total} 条`"
      :total="total"
      class="pagination"
      show-size-changer
      @change="pageChange"
      @showSizeChange="onShowSizeChange"
    />
    <!-- <no-data v-else></no-data> -->
  </div>
</template>

<script>
import touristList from '../../modules/cards/touristList.vue';
import sellTouristList from '../../modules/cards/sellTouristList.vue';
import List from './list.vue';

const tabsList = [
  {
    key: '1',
    title: '全部客源'
  },
  {
    key: '2',
    title: '我的客源'
  },
  {
    key: '3',
    title: 'B店客源'
  },
  {
    key: '8',
    title: 'A店客源'
  },
  {
    key: '4',
    title: '门店公客'
  },
  {
    key: '5',
    title: '公司公客'
  },
  {
    key: '6',
    title: '即将掉盘'
  },
  {
    key: '7',
    title: '草稿'
  }
]
export default {
  components: {
    touristList,
    sellTouristList,
    List
  },
  computed: {
    getPosition () {
      console.log(this.$getters.userInfo.position, 'this.$getters.userInfo.position')
      return this.$getters.userInfo.position
    },
    // 获取tabs,如总经理等无我的房源
    getTabs () {
      const arr = ['ZJL']
      const loginRole = this.$getters.userInfo.data.roles
      let status = false
      loginRole.forEach((el) => {
        console.log(el, arr.includes(el), '判断ZJL')
        if (arr.includes(el)) {
          status = true
        }
      })
      if (status) {
        this.tabsList = tabsList.filter((el) => el.key === '1')
      } else {
        this.tabsList = tabsList.filter((el) => el.key !== '1')
      }
      console.log(this.tabsList, 'this.tabsList')
      return this.tabsList
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    nameTouristComponent: {
      type: String,
      default: ''
    },
    activeNum: {
      type: [String, Number],
      default: ''
    },
    curLook: {
      type: Boolean,
      default: false
    },
    dateList: {
      type: Array,
      default: () => []
    },
    dataLists: {
      type: Array,
      default: () => []
    },
    dishTypeOpts: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: () => ({})
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    pageSize: {
      type: [Number, String],
      default: 10
    },
    pageNum: {
      type: [Number, String],
      default: 1
    },
    total: {
      type: [Number, String],
      default: 0
    }
  },
  watch: {
    dateList: {
      handler (val) {},
      deep: true,
      immediate: true
    },
    dataLists: {
      handler (val) {},
      deep: true,
      immediate: true
    },
    dishTypeOpts: {
      handler (val) {},
      deep: true,
      immediate: true
    },
    form: {
      handler (val) {},
      deep: true,
      immediate: true
    },
    pagination: {
      handler (val) {},
      deep: true,
      immediate: true
    },
    // 监听
    activeNum: {
      handler (val) {
        // 第一期修改 公客的地方不显示维护人 获取选中的tab是否属于公客 defaultActiveKey 绑定 改为 activeKey 修改原有选中tabs逻辑
        const arr = this.getTabs
        const ass = []
        arr.forEach((item) => {
          ass.push(item.key)
        })
        this.activeKey = ass.includes(val) ? val : arr[0] && arr[0].key
      },
      immediate: true
    }
  },
  data () {
    return {
      componentId: 'touristList',
      activeKey: '',
      tabsList
    }
  },
  mounted () {
    if (this.type === 'sale') {
      this.componentId = 'sellTouristList'
    } else {
      this.componentId = 'touristList'
    }
    console.log(this.$getters.userInfo, '00000')
  },
  methods: {
    GoSorter (requirementSort, sortType) {
      this.$emit('GoSorter', requirementSort, sortType)
    },
    changeTabs (item) {
      this.activeKey = item
      console.log(this.activeKey, item, '切换tabs')
      this.$emit('changeTabs', item)
    },
    changeUpDown () {
      this.$emit('changeUpDown')
    },
    dateListChange (item) {
      this.$emit('dateListChange', item)
    },
    pageChange (page, pageSize) {
      this.$emit('pageChange', page, pageSize)
    },
    onShowSizeChange (current, pageSize) {
      // console.log(current, pageSize);
      this.$emit('onShowSizeChange', current, pageSize)
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  margin-top: 10px;
  padding-bottom: 50px;
  background-color: white;

  .menu {
    padding-top: 20px;

    .searchMenu {
      margin-top: 10px;

      .item-box {
        display: flex;
        margin-left: 160px;

        & > div {
          width: 17%;
        }
      }

      /deep/ .ant-select-selection {
        width: 75px;
      }

      .cur {
        color: var(--ThemeColor);
      }
    }

    /deep/ .ant-tabs-nav-scroll {
      height: 37px;
    }

    /deep/ .ant-tabs-nav-container {
      margin-left: -20px;
      margin-bottom: -3px;
    }

    /deep/ .ant-tabs-bar {
      border-bottom: 3px solid var(--ThemeColor);
      padding-left: 20px;
      width: 98%;
      margin: 0 auto;
    }

    /deep/ .ant-tabs-content {
      padding-left: 10px;
    }

    /deep/ .ant-tabs-tab {
      margin-right: 0px;
      border: none;
      background-color: #ffffff;
    }

    /deep/ .ant-tabs-tab-active {
      background-color: var(--ThemeColor);
      color: #fff !important;
      border-radius: 5px;
    }

    .icons {
      display: flex;
      flex-wrap: wrap;
      width: 20px;
      height: 25px;
      cursor: pointer;
    }
  }

  .pagination {
    float: right;
    margin-right: 20px;
  }
}
</style>
